import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavComponent } from '@observation/shared/components/sidenav/sidenav.component';
import { MenuClickAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import {
  ACTION_TYPES,
  APPLICATION,
  GENERAL_ACTION_TYPES,
} from '../usage-tracking.config';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class SidenavButtonsTrackingService implements UsageTrackingServiceInterface {
  private readonly trackingService = inject(TrackingService);
  private readonly router = inject(Router);

  public addUsageTracking(
    element: SidenavComponent,
    args: [panel: string],
    actionName: string
  ): void {
    const buttonNames = {
      [ACTION_TYPES.filtersButtonClicked]: 'Filters',
      [ACTION_TYPES.areasButtonClicked]: 'Areas',
      [ACTION_TYPES.menuButtonClicked]: 'Menu',
      [ACTION_TYPES.homeButtonClicked]: 'Home',
      [ACTION_TYPES.goBackButtonClicked]: 'GoBack',
      [ACTION_TYPES.showKpisButtonClicked]: 'Show Kpis',
      [ACTION_TYPES.dashboardsButtonClicked]: 'Dashboards',
      [ACTION_TYPES.refreshButtonClicked]: 'Refresh',
      [ACTION_TYPES.logoutButtonClicked]: 'Logout',
      [ACTION_TYPES.adminButtonClicked]: 'Admin',
      [ACTION_TYPES.switchThemeButtonClicked]: 'Switch Theme',
      [ACTION_TYPES.activateMicrophoneButtonClicked]: 'Activate Microphone',
      [ACTION_TYPES.deactivateMicrophoneButtonClicked]: 'Deactivate Microphone',
      [ACTION_TYPES.highlightButtonClicked]: 'Highlight',
      [ACTION_TYPES.settingsButtonClicked]: 'Settings',
      [ACTION_TYPES.togglePanel]: args[0],
    };

    const buttonClicked = buttonNames[actionName];

    const action = GENERAL_ACTION_TYPES.menuClicked;
    const application = APPLICATION;

    const menuClickAnalytic: MenuClickAnalytic = {
      url: this.router.url,
      application,
      action,
      buttonClicked,
      isRightMenu: element?.positionRight,
    };

    this.trackingService.addUsageTracking(menuClickAnalytic);
  }
}
